<div class="modal-header">
  <h4 [innerHtml]="modalTitle" class="modal-title h5"></h4>
  <button (click)="onClose()" aria-label="Close" class="close" type="button">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="form-group">
    <label for="statusEventSignalSelection">
      <span translate>Select status event signal</span>
      @if (isLoadingStatusEventSignals ) {
        <span
        class="fa-solid fa-spinner fa-spin ml-2"></span>
      }
    </label>

    <div class="row">
      <div class="col">
        <ng-select (change)="onUpdateSelectedSignals($event)"
          [(ngModel)]="selectedStatusEventSignals"
          [searchable]="true"
          [closeOnSelect]="false"
          [multiple]="true"
          [items]="allStatusEventSignals"
          bindLabel="label"
          [placeholder]="'Select signals....' | translate"
          id="statusEventSignalSelection" name="statusEventSignalSelection">
          <ng-template let-item="item" ng-label-tmp>
            <span [innerText]="item.label | translate"></span>
          </ng-template>
          <ng-template let-item="item" ng-option-tmp>
            <div><span [innerText]="item.label | translate"></span></div>
            <small [innerText]="item.name"></small>
          </ng-template>
        </ng-select>

      </div>

    </div>
  </div>

  @if (selectedStatusEventSignals.length === 0 && !isLoadingStatusEventSignals) {
    <div class="alert alert-info" translate>
      Currently no status event signals are selected, please add some in the selector above.
    </div>
  }

</div>

<scitis-modal-footer (cancelButtonPressed)="onCancel()"
  (okButtonPressed)="onSavePageConfiguration()"
  [cancelButtonText]="'Cancel'|translate"
  [disableOkButton]="isLoadingStatusEventSignals"
  [okButtonText]="'Save'|translate"
  [showRequiredFieldsIndicator]="false">

</scitis-modal-footer>
